var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-marker',{attrs:{"lat-lng":_vm.position,"title":_vm.title,"draggable":false,"icon":_vm.$options.staticVars.greenIcon},on:{"click":_vm.selectMarker}})}
var staticRenderFns = []

export { render, staticRenderFns }